import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '@/components/ui/dialog';

export function EditUserDialog({ user, onClose, form, setForm, onSubmit, submitting }) {
  return (
    <Dialog open={!!user} onOpenChange={v => { if (!v) onClose(); }}>
      <DialogContent data-testid="edit-user-dialog">
        <DialogHeader>
          <DialogTitle>Modifier</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <Label>Nom</Label>
            <Input value={form.name} onChange={e => setForm({...form, name: e.target.value})} data-testid="edit-name" />
          </div>
          <div>
            <Label>Email</Label>
            <Input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} data-testid="edit-email" />
          </div>
          <div>
            <Label>Plan</Label>
            <Select value={form.plan} onValueChange={v => setForm({...form, plan: v})}>
              <SelectTrigger data-testid="edit-plan"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="STARTER">STARTER</SelectItem>
                <SelectItem value="PRO">PRO</SelectItem>
                <SelectItem value="PREMIUM">PREMIUM</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex items-center justify-between">
            <Label>Compte actif</Label>
            <Switch checked={form.isActive} onCheckedChange={v => setForm({...form, isActive: v})} data-testid="edit-active" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annuler</Button>
          <Button onClick={onSubmit} disabled={submitting} data-testid="edit-submit">Enregistrer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
